import React, {Component} from 'react'
import {Button} from 'react-foundation'

export class LoginForm extends Component  {
    state = {
        username: '',
        password: ''
    }
    onInputChange = (name, e) => {
        this.setState({[name]: e.target.value});
    }
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.onSubmit(this.state.username, this.state.password);
    }
    render() {
        return (
            <div>
                <div className="row align-center">
                    <div className="shrink columns">
                        <h1>Login</h1>
                    </div>
                </div>
                { this.props.loginError &&
                <div className="row align-center">
                    <div className="shrink columns">
                        <p>{this.props.loginError}</p>
                    </div>
                </div>
                }
                <form action="POST" onSubmit={this.handleSubmit}>
                    <div className="row align-center">
                        <div className="shrink columns">
                            <input type="text" placeholder="E-Mail" name="username"
                                   value={this.state.username}
                                   onChange={this.onInputChange.bind(this, 'username')}/>
                        </div>
                        <div className="shrink columns">
                            <input type="password" placeholder="Password" name="password"
                                   value={this.state.password}
                                   onChange={this.onInputChange.bind(this, 'password')}
                            />
                        </div>
                        <div className="shrink columns">
                            <Button type="submit">einloggen</Button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default LoginForm


// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js